<span *ngIf="(!url || !link)" [matTooltip]="value()">{{value()}}</span>
<ng-container *ngIf="url && link">
  <a *ngIf="!objectType" routerLink="{{url}}/{{key}}" matTooltip="Jump to {{value()}}">{{value()}}</a>
  <a *ngIf="objectType" (click)="dialogService.openDetail({objectType: objectType, objectId: this.key})" matTooltip="Open {{value()}}">{{value()}}</a>
</ng-container>
<ng-container *ngIf="!key">-</ng-container>
